const historyPackagesRouter = [
    {
        path: "list-history-payment",
        name: "historyPayment",
        component: () => import("@/views/admin/history-payment"),
        default: true,
        meta: {
            model: "history_payment",
            // requiresAuth: true,
        },
    },
    {
        path: "list-history-payment/add",
        name: "addHistoryPayment",
        component: () => import("@/views/admin/history-payment/function"),
        default: true,
        meta: {
            model: "history_payment",
            // requiresAuth: true,
        },
    },
    {
        path: "list-history-payment/edit/:id",
        name: "editHistoryPayment",
        component: () => import("@/views/admin/history-payment/function"),
        default: true,
        meta: {
            model: "history_payment",
            // requiresAuth: true,
        },
    },
];
export default historyPackagesRouter;